<template>
  <side-nav-section
    :user="user"
    :active="
      $route.name.includes('modules') ||
      $route.name.includes('course') ||
      $route.name.split('.')[0] === 'traq' ||
      $route.name === 'archive'
    "
    :section="consts.SIDENAV_MODULES_SECTION"
  >
    <template v-if="user.isUser">
      <side-nav-item :item="consts.SIDENAV_CLIENT_MODULES_ROUTE" />
      <side-nav-item :item="consts.SIDENAV_MODULES_CLIENT_JOIN_ROUTE" />
    </template>
    <template v-else-if="user.isTemplate">
      <side-nav-item :item="consts.SIDENAV_MODULES_PROVIDER_TEMPLATE_ROUTE" />
      <side-nav-item :item="consts.SIDENAV_MODULES_ARCHIVED_ROUTE" />
    </template>

    <template v-else>
      <side-nav-item
        :item="consts.SIDENAV_MODULES_COACH_PROVIDER_MODULES_ROUTE"
      />
      <side-nav-item
        :item="consts.SIDENAV_MODULES_COACH_PROVIDER_OTHER_ROUTE"
        v-if="user.isProvider"
      />
      <side-nav-item
        :item="consts.SIDENAV_MODULES_PROVIDER_TEMPLATE_ROUTE"
        v-if="user.isProvider"
      />
      <side-nav-item
        :item="consts.SIDENAV_MODULES_COACH_PROVIDER_MY_ROUTE"
        v-if="user.isExpert && !user.isProvider"
      />
      <side-nav-item :item="consts.SIDENAV_MODULES_ARCHIVED_ROUTE" />
    </template>
  </side-nav-section>
</template>

<script>
import {
  SIDENAV_MODULES_SECTION,
  SIDENAV_CLIENT_MODULES_ROUTE,
  SIDENAV_MODULES_CLIENT_JOIN_ROUTE,
  SIDENAV_MODULES_COACH_PROVIDER_MODULES_ROUTE,
  SIDENAV_MODULES_COACH_PROVIDER_OTHER_ROUTE,
  SIDENAV_MODULES_COACH_PROVIDER_MY_ROUTE,
  SIDENAV_MODULES_ARCHIVED_ROUTE,
  SIDENAV_MODULES_PROVIDER_TEMPLATE_ROUTE,
} from "Consts/sideNav/modulesSection";
import SideNavSection from "Public/components/SideNav/SideNavSections/SideNavSection";
import SideNavItem from "Public/components/SideNav/SideNavItem";
export default {
  name: "ModulesSection",
  components: { SideNavItem, SideNavSection },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      consts: {
        SIDENAV_MODULES_SECTION,
        SIDENAV_CLIENT_MODULES_ROUTE,
        SIDENAV_MODULES_CLIENT_JOIN_ROUTE,
        SIDENAV_MODULES_COACH_PROVIDER_OTHER_ROUTE,
        SIDENAV_MODULES_COACH_PROVIDER_MY_ROUTE,
        SIDENAV_MODULES_COACH_PROVIDER_MODULES_ROUTE,
        SIDENAV_MODULES_ARCHIVED_ROUTE,
        SIDENAV_MODULES_PROVIDER_TEMPLATE_ROUTE,
      },
    };
  },
};
</script>

<style scoped></style>
